import { SURVEY } from 'redux/constants/action-types';
import surveyClient from './surveyClient';

export function fetchAlertCount() {
  return async function (dispatch) {
    try {
      const response = await surveyClient.get('/alerts/count');
      dispatch({ type: SURVEY.GET_ALERT_COUNT, payload: response.data?.count ?? 0 });
    } catch {
      // non-critical — badge simply won't update
    }
  };
}

export function fetchAlerts(filters = {}) {
  return async function (dispatch) {
    try {
      const response = await surveyClient.get('/alerts', { params: filters });
      dispatch({ type: SURVEY.GET_ALERTS, payload: response.data });
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  };
}

export function fetchAlertDetail(alertId) {
  return async function (dispatch) {
    try {
      const response = await surveyClient.get(`/alerts/${alertId}`);
      dispatch({ type: SURVEY.GET_ALERT_DETAIL, payload: response.data });
      return response.data;
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  };
}

export function resolveAlertAction(alertId, request = {}) {
  return async function () {
    try {
      await surveyClient.patch(`/alerts/${alertId}/resolve`, request);
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  };
}

export function updateAlertAction(alertId, request) {
  return async function () {
    try {
      await surveyClient.patch(`/alerts/${alertId}`, request);
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  };
}

export function sendAlertEmailAction(alertId, request) {
  return async function () {
    try {
      const { data } = await surveyClient.post(`/alerts/${alertId}/send-email`, request);
      return data;
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  };
}
